import axios from "axios"
import * as actions from "../actions/systemParameter"
import { FAQ_URL, COMPLAINTS_URL, HOME_PAGE_TEXT, ANNUAL_RETURN_START, REGISTRATION_TEXT, ANNUAL_RETURN_PAGE_TEXT, DPC_NOTIFICATION_EMAIL } from '../js/const'

export function getSystemParameters() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter`)
      .then((response) => {
        let systemParameters = response.data ? response.data.$values : []
        dispatch(actions.getSystemParameters(systemParameters))
      })
  }
}

export function getHomePageText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${HOME_PAGE_TEXT}`)
      .then((response) => {
        let homePageText = response.data
        dispatch(actions.getHomePageText(homePageText))
      })
  }
}

export function getFaqUrl() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${FAQ_URL}`)
      .then((response) => {
        let faqUrl = response.data
        dispatch(actions.getFaqUrl(faqUrl))
      })
  }
}

export function getComplaintsUrl() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${COMPLAINTS_URL}`)
      .then((response) => {
        let complaintsUrl = response.data
        dispatch(actions.getComplaintsUrl(complaintsUrl))
      })
  }
}

export function getAnnualReturnStartYear() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${ANNUAL_RETURN_START}`)
      .then((response) => {
        let annualReturnStartYear = Number(response.data)
        dispatch(actions.getAnnualReturnStartYear(annualReturnStartYear))
      })
  }
}

export function getRegistrationText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${REGISTRATION_TEXT}`)
      .then((response) => {
        let registrationText = response.data
        dispatch(actions.getRegistrationText(registrationText))
      })
  }
}

export function getAnnualReturnPageText() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${ANNUAL_RETURN_PAGE_TEXT}`)
      .then((response) => {
        let annualReturnPageText = response.data
        dispatch(actions.getAnnualReturnPageText(annualReturnPageText))
      })
  }
}

export function getDPCNotificationEmail() {
  return (dispatch) => {
    return axios.get(`${process.env.REACT_APP_API_HOST}/api/system-parameter/${DPC_NOTIFICATION_EMAIL}`)
      .then((response) => {
        let dpcNotificationEmail = response.data
        dispatch(actions.getDPCNotificationEmail(dpcNotificationEmail))
      })
  }
}

export function updateSystemParameter(systemParameter) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put(`${process.env.REACT_APP_API_HOST}/api/system-parameter`, systemParameter)
        .then(response => {
          if (response.data.Success) {
            dispatch(actions.getSystemParameters(response.data.SuccessOutput.$values))
          }
          resolve(response)
        })
        .catch(error => reject(error))
    })
  }
}


// WEBPACK FOOTER //
// ./src/actionCreators/systemParameter.js